import { CatSkeleton } from '@blocks-react/components/Skeleton';
import cx from 'classnames';
import styles from './HeaderEquipmentWidgetLoading.module.scss';

export const HeaderEquipmentWidgetLoading = ({
  isMobile
}: {
  isMobile?: boolean;
}) =>
  isMobile ? (
    <div
      className={cx(
        'd-flex align-items-center',
        styles['equipment-widget-loading-mobile__container']
      )}
    >
      <div
        className={cx(
          'overflow-hidden',
          styles['equipment-widget-loading-mobile__skeleton']
        )}
      >
        <CatSkeleton />
      </div>
      <div
        className={cx(
          'overflow-hidden',
          styles['equipment-widget-loading-mobile__skeleton'],
          styles['equipment-widget-loading-mobile__skeleton-second']
        )}
      >
        <CatSkeleton />
      </div>
    </div>
  ) : (
    <div className="bg-white p-2" slot="custom">
      <div className="d-flex">
        <div
          className={cx(
            'overflow-hidden',
            styles['equipment-widget-loading-desktop__skeleton']
          )}
        >
          <CatSkeleton />
        </div>
        <div
          className={cx(
            'overflow-hidden ms-1',
            styles['equipment-widget-loading-desktop__skeleton'],
            styles['equipment-widget-loading-desktop__skeleton-second']
          )}
        >
          <CatSkeleton />
        </div>
      </div>
    </div>
  );
